import keyCodes from './keyCodes';
let keyDownListener
let keyUpListener

window.keyBackHandler = function() {
    console.log('window.keyBackHandler');
    keyDownListener && keyDownListener(keyCodes.back);
    keyUpListener && keyUpListener(keyCodes.back);    
}

export default { 
  set(downListener: ?Object,upListener:?Object) {
    window.document.onkeypress = this.grabDownEvent;
    window.document.onsystemevent = this.grabDownEvent;
    window.document.onirkeypress = this.grabDownEvent;
    window.document.onkeydown = this.grabDownEvent;
    window.document.onkeyup = this.grabUpEvent;
    keyDownListener = downListener;
    keyUpListener = upListener;
  },

  grabDownEvent(event){
        var e = event || window.event;
        e.preventDefault();
        // var key_code = e.which || e.keyCode;    
        keyDownListener && keyDownListener(e.keyCode);    
    },

    grabUpEvent(event){
        var e = event || window.event;
        e.preventDefault();
        // var key_code = e.which || e.keyCode;       
        keyUpListener && keyUpListener(e.keyCode);    
    },
}


// WEBPACK FOOTER //
// ./src/commonjs/keyListener.js